import React, { memo } from 'react';
import { Marker as MarkerLib, InfoWindow as InfoWindowLib } from '@react-google-maps/api';
import { useWindowSize } from '@yme/hooks/index';
import { getMarkerIcon } from './helpers';
export const Marker = memo(({ latitude, longitude, InfoWindow, infoWindowOptions, isActive, isInfoWindowOpened, clusterer, isSelected, onClick, handleCloseInfoWindow, }) => {
    const { isInfiniteDesktopView } = useWindowSize();
    const isActiveMarker = isInfoWindowOpened && isActive;
    const shouldShowInfoWindow = isInfoWindowOpened && isActive && isInfiniteDesktopView && InfoWindow;
    const icon = getMarkerIcon(isActiveMarker, isSelected);
    const position = {
        lat: latitude,
        lng: longitude,
    };
    return (React.createElement(MarkerLib, { position: position, icon: icon, onClick: onClick, clusterer: clusterer }, shouldShowInfoWindow && (React.createElement(InfoWindowLib, { onCloseClick: handleCloseInfoWindow, options: {
            ...infoWindowOptions,
            position,
        } },
        React.createElement("div", null, InfoWindow)))));
});
Marker.displayName = 'Marker_Component';
